import { createFileRoute } from "@tanstack/react-router";
import { createFormData, useSimpleForm } from "@/hooks/use-simple-form";
import useAppStore from "@/store";
import { useTranslate } from "@/hooks/use-translate";
import { Button } from "@/components/ui/button";
import { unPick } from "@/lib/utils";
import ServiceTest from "@/components/service/service-test";
import { ServiceForm } from "@/components/service/service-form";

export const Route = createFileRoute("/(dasboard)/products/services/create")({
  component: CreateServicePage,
});

function CreateServicePage() {
  const store = useAppStore();
  const { t } = useTranslate();

  const form = useSimpleForm({
    name: "",
    description: "",
    category_id: "",
    featured_image: {
      file: undefined,
      src: undefined,
    },
    images: [],
    //
    selling_price: 0,
    unit_price: 0,
  });

  const submit = async () => {
    store.errors.reset();
    const data = {
      ...unPick(form.values, ["featured_image"]),
      shop_id: store.auth.session?.currentShop?.id,
    };

    // Find the index of the featured image
    if (form.values.featured_image) {
      for (let i = 0; i < form.values.images.length; i++) {
        if (form.values.images[i].id == form.values.featured_image.id)
          data["featured_image_index"] = i;
      }
    }

    store.service
      .create(createFormData(data))
      .then(() => {
        store.service.fetch();
        window.history.back();
        form.reset();
      })
      .catch(store.errors.catch);
  };

  return (
    <section className="max-auto">
      {store.testing.canTest && <ServiceTest form={form} submit={submit} />}
      <div className="mt-4 flex justify-between mb-4">
        <h2 className="text-xl font-semibold">{t("Add service")}</h2>
        <div>
          <Button
            onClick={submit}
            loading={store.service.loading("create")}
            className="py-2"
          >
            {t("Add service")}
          </Button>
        </div>
      </div>

      <div>{store.errors.render()}</div>

      {/* Use the ProductForm component with the initialized form */}
      <ServiceForm mode="create" form={form} />

      <Button
        className="mt-8 px-6 py-3"
        onClick={submit}
        loading={store.service.loading("create")}
      >
        {t("Add service")}
      </Button>
    </section>
  );
}
